<script lang="ts" setup>
import {
  AppLink,
} from '#components'
import { useDynamicIcons } from '~layers/shared/utils/useDynamicIcons.ts'

const { loadLayout, layoutData } = useLayout()
await loadLayout()

function getElement(to: any) {
  return to ? AppLink : 'span'
}

// function loadIcon(icon: string) {
//   icon = icon.toLowerCase()
//   return `icon:social-media-${icon}`
// }

const { loadIcon } = useDynamicIcons()
</script>

<template>
  <div
    class="social-icons"
  >
    <div
      v-if="layoutData?.socialIcons?.[0]?.Title"
      class="social-icons__title"
    >
      {{ layoutData?.socialIcons?.[0]?.Title }}
    </div>

    <ul
      v-if="layoutData?.socialIcons?.[0]?.Icons?.length"
      class="social-icons__list"
    >
      <li
        v-for="(group, index) in layoutData?.socialIcons?.[0]?.Icons"
        :key="index"
      >
        <component
          :is="getElement(group.Link)"
          class="social-icons__link"
          :class="`${group.Name.toLowerCase().replace(/\s/g, '')}`"
          :to="group.Link"
          :aria-label="group.Name"
        >
          <Icon
            v-if="group.Icon"
            :name="loadIcon(group.Icon)"
            class="icon"
            :class="`${group.Icon.toLowerCase()}`"
          />
        </component>
      </li>
    </ul>
  </div>
</template>

<style>
@import url("~layers/app/components/App/Socials.css");
</style>
